exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auto-text.clip{overflow:hidden;white-space:nowrap;text-overflow:clip}.auto-text.break{word-break:break-word}.auto-text.ellipsis{overflow:hidden;text-overflow:ellipsis;min-width:0;white-space:nowrap}", ""]);

// exports
